import React from 'react';
import { Button } from 'antd';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { stopTimer } from 'modules/blok-test';
import { setConfirmationModal } from 'modules/global';
import { useFinishTest } from 'modules/mavzuli-test';
import { setVisibleXpModal } from 'modules/results';

import { Modal } from 'components';

interface IProps {
  ticketId?: number;
  testType: string;
  isExam?: boolean;
  onConfirm?: () => void;
  onAfterClose?: () => void;
}

const ConfirmationModal: React.FC<IProps> = ({ onAfterClose, ticketId, onConfirm }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const open = useAppSelector(({ confirmationModal }) => confirmationModal.open);
  const { finishTest, isLoading } = useFinishTest({
    onClose: onAfterClose
  });
  const isRouteLoading = useAppSelector(state => state.routeLoading.isRouteLoading);

  const onOk = () => {
    finishTest(ticketId as number);
    dispatch(stopTimer());

    if (onConfirm) {
      onConfirm();
    }

    dispatch(setVisibleXpModal(true));
  };

  const onClose = () => {
    dispatch(setConfirmationModal(false));

    if (onAfterClose) onAfterClose();
  };

  return (
    <Modal
      centered
      open={open}
      width="380px"
      footer={false}
      onClose={onClose}
      closeIcon={false}
      styles={{
        content: { padding: '8px 10px 3px 10px', borderRadius: '12px' }
      }}
    >
      <div className="mb-5 flex flex-col items-center justify-center">
        <div className="size-15 relative">
          <Image src="/images/confirmation.webp" fill alt="Confirmation" title="Confirmation" />
        </div>
        <p className="mt-3 text-lg font-semibold">{t('testni_yakunlashni_xohlaysizmi')}</p>
        <p className="mt-2 px-5 text-center text-gray-400">{t('testni_yakunlashni_xohlaysizmi_decs')}</p>
      </div>
      <div className="mt-10 flex items-center gap-2">
        <Button
          onClick={onClose}
          className="!py-4.5 !w-full !rounded-md !border-transparent !bg-gray-100 !text-black hover:!bg-gray-200"
        >
          {t('bekor_qilish')}
        </Button>
        <Button
          onClick={onOk}
          loading={isLoading || isRouteLoading}
          className="!py-4.5 !w-full !rounded-md !border-transparent !bg-red-500 !text-white hover:!bg-red-600"
        >
          {t('yakunlash')}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
